import React from "react";
import styled from 'styled-components';
import logo from '../../img/logo.png';
import RightNav from './RightNav';
import Burger from './Burger';
import { Link } from "react-router-dom";

const Nav = styled.div`
    background-color: #fff;
    border-bottom: 2px solid #095EB2;
    
`;

const NavHeader = styled.div`
    max-width: 90%;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;

    .logo {
        padding-top: 15px;
    }
    
`;

const Header = (props) => (
    <Nav id='page-wrap'>
        <NavHeader>
            <Link to='/'>
                <div className="logo">
                    <img src={logo} />
                </div>
            </Link>
            <RightNav/>
            <Burger pageWrapId={"page-wrap"} outerContainerId={"App"} bg={props.bg}/>
        </NavHeader> 
    </Nav>
);

export default Header;